export default {"src":"/_next/static/media/swipe-left.ecde69ed.svg","height":18,"width":10};